import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type { Methodology } from '../../types'
import * as enums from '../enums'

const DOC = gql`
  query SpaceRecordFunctionalUsageLite(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceRecordFunctionalUsage(spaceRecordId: $spaceRecordId) {
                  functionalizationMethodology
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.SpaceRecordFunctionalUsageLiteQuery,
  Methodology | undefined,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'extra',
          graphql.transformers.OUT.select(
            'space',
            graphql.transformers.OUT.select(
              'spaceRecordFunctionalUsage',
              graphql.transformers.OUT.select(
                'functionalizationMethodology',
                enums.SPACE_RECORD_FUNCTIONAL_METHODOLOGY,
              ),
            ),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.SpaceRecordFunctionalUsageLiteQuery,
  Methodology | undefined,
  graphql.schema.SpaceRecordFunctionalUsageLiteQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
